import Palette from '@opsbase/lib-palette';
import useOpDefinitionOpCount from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitionOpCount';
import useCss from '@opsbase/web-css';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import React from 'react';
import GeneralOverviewSection from './overviewsections/GeneralOverviewSection';
import IssuesOverviewSection from './overviewsections/IssuesOverviewSection';
import Last7DaysOverviewSection from './overviewsections/Last7DaysOverviewSection';
import LatestPerfOverviewSection from './overviewsections/LatestPerfOverviewSection';
import OpCountOverviewSection from './overviewsections/OpCountOverviewSection';
import QuestionCountOverviewSection from './overviewsections/QuestionCountOverviewSection';
import TimestampsOverviewSection from './overviewsections/TimestampsOverviewSection';
import ValidityOverviewSection from './overviewsections/ValidityOverviewSection';
const makeMyClasses = () => ({
    container: {
        alignContent: 'flex-start',
    },
    large: {
        padding: 8,
        width: '100%',
        height: 596,
    },
    medium: {
        padding: 8,
        width: '100%',
        height: 295,
    },
    mediumtall: {
        padding: 8,
        width: '100%',
        height: 338,
    },
    small: {
        padding: 8,
        width: '48%',
        height: 122,
    },
    smallWide: {
        padding: 8,
        width: '100%',
        height: 122,
    },
});
export const makeSectionClasses = () => ({
    massiveText: {
        margin: '32px auto',
        fontSize: 38,
        lineHeight: '38px',
        display: 'block',
        width: 'fit-content',
    },
    openButton: {
        backgroundColor: Palette.BackgroundGrey.main,
        '&:hover': {
            opacity: 1,
        },
    },
});
export function OpDefinitionEditOverviewTab(props) {
    const myCss = useCss(makeMyClasses);
    const { loading: opCountLoading, data: opCount } = useOpDefinitionOpCount({
        variables: { id: props.opDefinition.id },
        skip: !props.opDefinition,
    });
    const sectionprops = { ...props, opCountLoading, opCount, classes: myCss };
    return (React.createElement(Vertical, { padding: true, gutter: true },
        React.createElement(Horizontal, { gutter: true },
            React.createElement(Horizontal, { flexWrap: "wrap", classes: { root: myCss.container } },
                React.createElement(GeneralOverviewSection, { ...sectionprops, className: myCss.mediumtall }),
                React.createElement(QuestionCountOverviewSection, { ...sectionprops, className: myCss.small }),
                React.createElement(OpCountOverviewSection, { ...sectionprops, className: myCss.small }),
                React.createElement(ValidityOverviewSection, { ...sectionprops, className: myCss.smallWide })),
            React.createElement(Horizontal, { flexWrap: "wrap", classes: { root: myCss.container } },
                React.createElement(Last7DaysOverviewSection, { ...sectionprops, className: myCss.medium }),
                React.createElement(IssuesOverviewSection, { ...sectionprops, className: myCss.medium })),
            React.createElement(Horizontal, { flexWrap: "wrap", classes: { root: myCss.container } },
                React.createElement(LatestPerfOverviewSection, { ...sectionprops, className: myCss.large }))),
        React.createElement(TimestampsOverviewSection, { ...sectionprops }),
        React.createElement(Pane, { grow: true })));
}
export default OpDefinitionEditOverviewTab;
